import styled from "@emotion/styled";
import {TVehicleConfiguration, TVehiclePieceCountValue} from "./VehicleConfiguration";
import VehicleConfigurationItem from "./VehicleConfigurationItem";
import {Tooltip} from "@blueprintjs/core";
import {InformationIcon} from "../../common/icons";
import {MAX_DWELL_MINUTES, MIN_DWELL_MINUTES} from "../CompanySettings/common/constants";
import {PIECE_COUNT_TOOLTIP, gridTemplateColumns} from "./VehicleConfiguration.constants";

type VehicleIconTableProps = {
  configuration: TVehicleConfiguration[];
  showPieceCount: boolean;
  existingAssociatedStrings: string[];
  onUpdateConfiguration: (prefItem: TVehicleConfiguration, clearPieceCount?: boolean) => void;
  onUpdatePieceCount: (id: string, value: TVehiclePieceCountValue) => void;
};

const VehicleConfigurationTable = ({
  configuration,
  showPieceCount,
  existingAssociatedStrings,
  onUpdateConfiguration,
  onUpdatePieceCount
}: VehicleIconTableProps) => {
  return (
    <Table data-testid="vehicle-configuration-table">
      <Header hasPieceCount={showPieceCount}>
        <HeaderCell style={{margin: "auto"}}>Icon</HeaderCell>
        <HeaderCell>Associated strings</HeaderCell>
        <HeaderCell>
          Dwell Time (min)
          <Tooltip
            content={
              <div>
                Vehicle Dwell Time.
                <br />
                Minimum: {MIN_DWELL_MINUTES} minute, Maximum: {MAX_DWELL_MINUTES} minutes.
              </div>
            }
            placement="top"
            popoverClassName="content-tooltip"
            targetProps={{style: {marginTop: "3px"}}}
          >
            <InformationIcon scale={0.6} />
          </Tooltip>
        </HeaderCell>
        {showPieceCount && (
          <HeaderCell data-testid="piece-count-header">
            Piece Count
            <Tooltip
              content={<div>{PIECE_COUNT_TOOLTIP}</div>}
              placement="top"
              popoverClassName="content-tooltip"
              targetProps={{style: {marginTop: "3px"}}}
            >
              <InformationIcon scale={0.6} />
            </Tooltip>
          </HeaderCell>
        )}
      </Header>
      <Body>
        {configuration.map((item) => (
          <VehicleConfigurationItem
            key={item.id}
            configuration={item}
            showPieceCount={showPieceCount}
            existingAssociatedStrings={existingAssociatedStrings}
            onUpdateConfiguration={onUpdateConfiguration}
            onUpdatePieceCount={onUpdatePieceCount}
          />
        ))}
      </Body>
    </Table>
  );
};

export default VehicleConfigurationTable;

const Table = styled.div`
  flex: 1;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  height: fit-content;
`;

const Header = styled.div<{hasPieceCount: boolean}>`
  background-color: #f3f4f6;
  color: #4b5563;
  text-transform: uppercase;
  display: grid;
  grid-template-columns: ${({hasPieceCount}) => gridTemplateColumns(hasPieceCount)};
  font-size: 14px;
`;

const HeaderCell = styled.div`
  padding: 16px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Body = styled.div`
  div:nth-last-child(1) {
    border-bottom: none;
  }
`;
